import React from "react";

const AffectedPayment = () => (
  <div>
    <h2>Paiements affectés</h2>
    {/* Add your affected payment content here */}
  </div>
);
export default AffectedPayment;